import { useCallback } from 'react';

import { QuantityAbbreviation } from '@dreryk/drerykweb-medicine-api';

import { useTranslate } from '@dreryk/react-common';
import { InteractiveTable, InteractiveTableCellProps, useInteractiveTableContext } from '@dreryk/react-components';

import { magistralDrugTranslationKeys, prescriptionsTranslationKeys } from '../../../../../../translations';

import { MedicineRawMaterialTableBean } from './MedicineRawMaterialTable.types';

type QuantityAbbreviationSelectCellProps = InteractiveTableCellProps<QuantityAbbreviation | null>;

export const useTriggerLabelExtractor = (): ((item?: QuantityAbbreviation) => string) => {
   const translate = useTranslate();

   return useCallback(
      (item) => {
         if (!item) {
            return '';
         }
         return translate(prescriptionsTranslationKeys.quantityAbbreviation[item]);
      },
      [translate]
   );
};

const QUANTITY_ABBREVIATIONS: QuantityAbbreviation[] = [
   'QUANTUM_SATIS',
   'A',
   'ANA_PARTES_AEQUALES',
   'ANA_PARTES_AEQUALES_AD',
   'AD',
];

export const QuantityAbbreviationSelectCell = (props: QuantityAbbreviationSelectCellProps): JSX.Element => {
   const { getCellValue, setCellValue } = useInteractiveTableContext<MedicineRawMaterialTableBean>();
   const triggerLabelExtractor = useTriggerLabelExtractor();

   const handleQuantumSatisSelection = useCallback((): void => {
      if (!getCellValue('rpw', props.index)) {
         setCellValue('quantity', props.index, null);
      }
   }, [props.index, getCellValue, setCellValue]);

   const handleSelect = useCallback(
      (bean: QuantityAbbreviation | undefined): void => {
         if (bean === 'QUANTUM_SATIS') {
            handleQuantumSatisSelection();
         }
      },
      [handleQuantumSatisSelection]
   );
   return (
      <InteractiveTable.SelectCell<QuantityAbbreviation>
         testId={props.testId}
         name={props.name}
         index={props.index}
         validationRules={props.validationRules}
         defaultValue={props.defaultValue}
         triggerLabelExtractor={triggerLabelExtractor}
         placeholder={magistralDrugTranslationKeys.medicineRawMaterials.quantityAbbreviationPlaceholder}
         onSelect={handleSelect}
      >
         <InteractiveTable.SelectCell.List items={QUANTITY_ABBREVIATIONS}>
            {(abbreviation) => (
               <InteractiveTable.SelectCell.Item
                  testId={abbreviation}
                  item={abbreviation}
                  label={prescriptionsTranslationKeys.quantityAbbreviation[abbreviation]}
               />
            )}
         </InteractiveTable.SelectCell.List>
      </InteractiveTable.SelectCell>
   );
};
